export type UnitPayback = {
  progressPercentage: number
  displayPercentage: number
  profitPence: number | null
}

// Match Arctic Line's payoff rules, keeping calculations in pence.
export function calculateUnitPayback(purchasePricePence: number | null, revenuePence: number): UnitPayback | null {
  if (purchasePricePence == null || !Number.isFinite(purchasePricePence) || purchasePricePence <= 0
    || !Number.isFinite(revenuePence) || revenuePence < 0) return null
  const rawPercentage = revenuePence / purchasePricePence * 100
  const isPaidOff = revenuePence >= purchasePricePence
  return {
    progressPercentage: Math.min(rawPercentage, 100),
    displayPercentage: isPaidOff ? 100 : Math.min(Math.floor(rawPercentage), 99),
    profitPence: isPaidOff ? revenuePence - purchasePricePence : null,
  }
}

const wholePounds = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 })
export function formatUnitProfit(profitPence: number) {
  return `+ £${wholePounds.format(Math.floor(profitPence / 100))}`
}
